module.exports = __webpack_public_path__ + "img/3.f17a30b0.jpeg";